import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import HobbyItem from "./HobbyItem";

export default function HobbyList() {
    const { hobbies } = useResumeDocumentSection();

    return (
        <div>
            { hobbies
                ?.sort( ( a, b ) => a.order - b.order )
                .map( hobby => (
                    <HobbyItem
                        key={ hobby.order }
                        item={ hobby }
                        numberOfItems={ hobbies.length }
                    />
                ) ) }
        </div>
    );
};
